import React, { useEffect, useState } from 'react'
import {
  CAvatar,
  CBadge,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CButton,
} from '@coreui/react-pro'
import {
  cilBell,
  cilCreditCard,
  cilCommentSquare,
  cilEnvelopeOpen,
  cilFile,
  cilLockLocked,
  cilSettings,
  cilTask,
  cilUser,
  cilAccountLogout,
  cilQrCode,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'

// import avatar8 from './../../assets/images/avatars/8.jpg'
// import avatar5 from './../../assets/images/avatars/5.jpg'
import * as cusUtil from 'src/viewsCommon/CusUtil'
import U_UserDetailModal from 'src/viewsCus/user/U_UserDetailModal'
import SpaceUseDetailUser from 'src/viewsCus/_company/space/pwan/SpaceUseDetailUser_pwan'
// import P2PVideoCall from 'src/components/P2PVideoCall'

const AppHeaderDropdown = (param) => {
  const userPermission = cusUtil.checkUserPermission()
  console.log('userPermission ', userPermission)

  var userName = '로그인이 필요합니다.'
  if (cusUtil.getJwtToken()) {
    userName = '안녕하세요 ' + cusUtil.getJwtToken().sub + ' 님'
  }

  const [dataList, setDataList] = useState([])
  const [searchCondition, setSearchCondition] = useState({})
  const fetchData = async () => {
    if (userPermission) {
      // 검색조건
      const currentDateStart = cusUtil.getCurrentDtTimeStr() + '00'
      const currentDateEnd = cusUtil.getCurrentDtTimeStr() + '00'
      let searchConditionUrl =
        'startDtStart=' + currentDateStart + ',endDtEnd=' + currentDateEnd + ','
      Object.keys(searchCondition).forEach((key) => {
        if (searchCondition[key]) {
          searchConditionUrl += key + '=' + searchCondition[key] + ','
        }
      })
      // console.log('list url searchConditionUrl: ', searchConditionUrl)
      searchConditionUrl = 'search=' + encodeURIComponent(searchConditionUrl)

      const url = `/cube_dev_local/api/user/order/orderGoodsPwanDetailsList/spaceUseList/simple/my?offset=0&limit=1&order=regDt=descend&${searchConditionUrl}`
      console.log('list url: ', url)

      cusUtil
        .cusfetch('GET', url)
        .then((response) => response.json())
        .then((response) => {
          setDataList(response.list)
          // console.log('spaceUseList header success: ', response.list)
          // console.log('spaceUseList header success: ', response.list[0].spaceUseUid)
        })
        .catch((error) => {
          console.error('spaceUseList header fail: ', error)
        })
    }
  }

  // 최초실행
  useEffect(() => {
    fetchData()
  }, [])

  return (
    <>
      {(() => {
        // 상단 qr 코드 보여주는 부분
        // if (userPermission === 'user') {
        //   // console.log('spaceUseList header dataList: ', dataList[0].spaceUseUid, dataList.length)
        //   if (dataList && dataList.length > 0) {
        //     // console.log('spaceUseList header dataList 2 : ', dataList[0].spaceUseUid)
        //     return <SpaceUseDetailUser uid={dataList[0].spaceUseUid} title="" count="1" />
        //   } else {
        //     // console.log('spaceUseList header dataList 3 : ')
        //     return <SpaceUseDetailUser uid="" title="" count="0" />
        //   }
        // } else {
        //   return <></>
        // }
      })()}
      {/* <P2PVideoCall></P2PVideoCall> */}

      <CDropdown variant="nav-item" alignment="end">
        <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
          <CButton color="primary" className="position-relative px-1 py-1 me-0" variant="ghost">
            <CIcon icon={cilUser} className="" size="lg" />
          </CButton>
          {/* <CAvatar src={avatar5} size="md" status="success" /> */}
          {/* <CAvatar src={avatar5} size="md" /> */}
          {/* <CIcon icon={cilUser} className="me-2" size="xl" /> */}
        </CDropdownToggle>
        <CDropdownMenu className="pt-0">
          <U_UserDetailModal title={userName} />
          {/* 
        <CDropdownHeader className="bg-light dark:bg-white dark:bg-opacity-10 fw-semibold py-2">
          Account
        </CDropdownHeader>
        <CDropdownItem href="#">
          <CIcon icon={cilBell} className="me-2" />
          Updates
          <CBadge color="info-gradient" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilEnvelopeOpen} className="me-2" />
          Messages
          <CBadge color="success-gradient" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilTask} className="me-2" />
          Tasks
          <CBadge color="danger-gradient" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilCommentSquare} className="me-2" />
          Comments
          <CBadge color="warning-gradient" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownHeader className="bg-light dark:bg-white dark:bg-opacity-10 fw-semibold py-2">
          Settings
        </CDropdownHeader>
        <CDropdownItem href="#">
          <CIcon icon={cilUser} className="me-2" />
          Profile
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilSettings} className="me-2" />
          Settings
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilCreditCard} className="me-2" />
          Payments
          <CBadge color="secondary-gradient" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilFile} className="me-2" />
          Projects
          <CBadge color="primary-gradient" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem href="#">
          <CIcon icon={cilLockLocked} className="me-2" />
          Lock Account
        </CDropdownItem> */}
        </CDropdownMenu>
      </CDropdown>
    </>
  )
}

export default AppHeaderDropdown
